import { render, staticRenderFns } from "./TournamentRadio.vue?vue&type=template&id=a47d9bc6&"
import script from "./TournamentRadio.vue?vue&type=script&lang=js&"
export * from "./TournamentRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports